'use client';

import {
	Authenticator as AwsAuthenticator,
	type AuthenticatorProps as AwsAuthenticatorProps,
	useAuthenticator as useAuthenticatorHook,
	withAuthenticator as withAuthenticatorHook,
} from '@aws-amplify/ui-react';
import React, { ReactNode } from 'react';

interface AuthenticatorProps extends AwsAuthenticatorProps {
	children?: ReactNode;
	loginMechanisms: ('username' | 'email' | 'phone_number')[];
	signUpAttributes: ('given_name' | 'family_name')[];
	passwordSettings: {
		minLength: number;
		requireSpecialCharacters: boolean;
	};
	components?: any;
	formFields?: any;
}

export const Authenticator: React.FC<AuthenticatorProps> = ({
	children,
	loginMechanisms,
	signUpAttributes,
	passwordSettings,
	components,
	formFields,
	...props
}) => (
	<AwsAuthenticator
		loginMechanisms={loginMechanisms}
		signUpAttributes={signUpAttributes}
		passwordSettings={passwordSettings}
		components={{
			...(components ?? {}),
			SignIn: {
				Footer: () => null,
			},
		}}
		formFields={formFields ?? {}}
		{...props}
	>
		{children}
	</AwsAuthenticator>
);

export const useAuthenticator = useAuthenticatorHook;
export const withAuthenticator = withAuthenticatorHook;
